<template>
  <el-tooltip placement="right" effect="light">
    <span class="show-text">{{ textMap[opCode] }}</span>
    <template #content>
      <el-steps class="step-wrapper" direction="vertical" :active="activeKey" finish-status="success">
        <el-step v-for="(obj, index) in config" :key="+index" :title="obj.name">
          <template #description>
            <el-button v-if="+index === activeKey && !obj.disabled" type="text" @click="handleRemind">一键提醒</el-button>
          </template>
        </el-step>
      </el-steps>
    </template>
  </el-tooltip>
</template>

<script>
import { toMap } from '@/utils/objUtil'

export default {
  name: 'StatusFlow',
  props: {
    config: {
      type: Array,
      required: true
    },
    opCode: {
      type: Number,
      default: 0
    },
  },
  computed: {
    /**
     * @returns{Object}
     */
    textMap() {
      return toMap(this.config)
    },
    /**
     * @returns{Number}
     */
    activeKey() {
      return this.config.findIndex(v => v.id === this.opCode)
    }
  },
  methods: {
    handleRemind() {
      this.$emit('remind')
    }
  }
}
</script>

<style scoped>
.step-wrapper {
  width: 200px;
  height: 300px;
  padding: 10px;
}
.show-text {
  cursor: pointer;
  color: #4071ff;
}
</style>
